import usePageTitle from "@/hooks/usePageTitle";

export default function PageTitle({ pattern, title }: { pattern: string; title: string }) {
  usePageTitle(pattern, title);
  return null;
}
